module.exports = __webpack_public_path__ + "static/media/uc_wordmark_stacked_gray.41258bb1.png";